// extracted by mini-css-extract-plugin
export default {"blog":"Blog_blog__j+iUK","blogTitle":"Blog_blogTitle__WI+GD"};